import { MenuPromotionSmallProductCard, ProductTypes } from 'modules/products'

import styles from './CategoriesButtonMenuMultiplePromotions.module.scss'

const CategoriesButtonMenuMultiplePromotions = ({
  menuPromotionItems
}: {
  menuPromotionItems: ProductTypes[]
}) => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>
        Lokalny Rolnik poleca!
      </h3>
      <div className={styles.listWrapper}>
        {menuPromotionItems.map((product, i) => (
          <MenuPromotionSmallProductCard
            idxOnList={i}
            product={product}
            seoButtonPlace={product.slug}
            productPath={product.slug}
            key={`category-menu-promotion-${i}`}
          />
        ))}
      </div>
    </div>
  )
}

export default CategoriesButtonMenuMultiplePromotions
